export default __webpack_public_path__ + "static/daniel-ter-nedden-dd043fcc227344d171cf03be3f029200.jpg";